<template>
  <div class="events-filters pl-s el-size--small" :class="css">
    <div v-for="filter in filtersExcludeDate" :key="filter.title">
      <h4
        class="mb-m text--xs font-bd"
        v-text="localize(filter.title) + ':'"
      ></h4>
      <ul class="no-style">
        <li v-for="option in uniqify(filter.list, 'label')" :key="option.label">
          <label>
            <span :class="['check', !!option.active ? 'checked' : '']"
              ><input
                v-model="option.active"
                @input="filterChangeHandler"
                type="checkbox"
                hidden
            /></span>
            <span
              class="lbl text--xs text-gray-8 font-rg ml-s"
              v-text="option.label"
            ></span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    children: Array,
    title: String,
    css: String
  },
  methods: {
    ...mapActions(["setEventsFilter"]),
    filterChangeHandler(id) {
      console.log("filterChangeHandler");
      this.setEventsFilter(this.filters);
    },
    uniqify(list, by) {
      return _.uniqBy(list, by);
    }
  },
  computed: {
    ...mapState({
      filters: state => state.events.filters
    }),
    filtersExcludeDate() {
      return this.filters.filter(filter => filter.prop !== "date");
    }
  }
};
</script>

<style lang="stylus" scoped>
ul
  text-align left
li
  margin-bottom 8px
  .check
    inline-mid()
    position relative
    border 1px solid gray_4
    width 22px
    height @width
    &:before
      content ''
      position absolute
      opacity 0
      top 50%
      left 50%
      width 6px
      height 3px
      border-left 1px solid #7f949f
      border-bottom 1px solid #7f949f
      transform scale(0) translate(-50%,-80%) rotate(360deg)
      transition opacity 0.2s ease-out, transform 0.25s ease-out
    &.checked
      check()
</style>
